var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfinityWalletLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 322.4 194.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2,.cls-3,.cls-4,.cls-6,.cls-7,.cls-8{opacity:0.49;}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-5);}.cls-6{fill:url(#linear-gradient-6);}.cls-7{fill:url(#linear-gradient-7);}.cls-8{fill:url(#linear-gradient-8);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 728.58,
    y1: 394.83,
    x2: 728.58,
    y2: 771.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00bfe1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#2738ab"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 657.01,
    y1: 527.42,
    x2: 681.29,
    y2: 547.73,
    gradientTransform: "translate(-0.94 -0.61)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#1b1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b1464",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 748.73,
    y1: 568.31,
    x2: 737.17,
    y2: 584.71,
    gradientTransform: "translate(1499 1160.09) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 781.33,
    y1: 718.83,
    x2: 790.02,
    y2: 697.36,
    gradientTransform: "translate(1499 1160.09) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 871.42,
    y1: 394.83,
    x2: 871.42,
    y2: 771.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 753.2,
    y1: 227.52,
    x2: 777.48,
    y2: 247.83,
    gradientTransform: "translate(1697.13 734.66) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 652.54,
    y1: 868.22,
    x2: 640.97,
    y2: 884.62,
    gradientTransform: "translate(197.19 -426.04)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 685.14,
    y1: 1018.73,
    x2: 693.82,
    y2: 997.26,
    gradientTransform: "translate(197.19 -426.04)",
    xlinkHref: "#linear-gradient-2"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Infinity8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M814.71,466.49a2.53,2.53,0,0,0-4.14-.86l-5.12,5.12-.84.84-40.69-40.41a39.48,39.48,0,0,0-55.71,0l-57.91,58a39.76,39.76,0,0,0,0,55.94l58,57.67a39.39,39.39,0,0,0,55.65,0l13.18-13.18A19.87,19.87,0,0,0,782,582.4a16.53,16.53,0,0,0-2-15,16,16,0,0,0-1.95-2.32,16.54,16.54,0,0,0-23.22.1l-14.22,14.23a6.24,6.24,0,0,1-3.11,1.72,5.56,5.56,0,0,1-3.36-.2,7.74,7.74,0,0,1-3-1.89l-57.58-57.58a6.34,6.34,0,0,1-1-7.78l.3-.34c.67-.69,58.11-58,58.63-58.55a6.3,6.3,0,0,1,3.34-1.75,6.78,6.78,0,0,1,1.16-.11,6.31,6.31,0,0,1,4.5,1.87l40.57,40.29-2,2-4,4a2.53,2.53,0,0,0,.85,4.14l36.6,4.5a5.81,5.81,0,0,0,5.73-5.76Z",
    transform: "translate(-638.8 -419.68)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M673.17,521a6.29,6.29,0,0,1-.5-7.28s-19.06,20.79-9.9,43.81l12.06,12,17.58-29.2Z",
    transform: "translate(-638.8 -419.68)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M732.52,580.26C754,600,777.66,589,777.66,589A17.94,17.94,0,0,0,782,582.4c-3.18-1.56-26.27-18.08-26.27-18.08L742.1,578C737.21,583.84,732.52,580.26,732.52,580.26Z",
    transform: "translate(-638.8 -419.68)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M718.37,468.1s13.77-13.85,13.8-13.79,3.67-2.94,7.53-.23c0,0-22.87-18.83-47.33-7l-7.15,7.16Z",
    transform: "translate(-638.8 -419.68)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M785.29,567.46a2.52,2.52,0,0,0,4.14.86l5.12-5.11.84-.85,40.69,40.42a39.47,39.47,0,0,0,55.71,0l57.91-58a39.76,39.76,0,0,0,0-55.94l-58-57.68a39.41,39.41,0,0,0-55.65,0L822.9,444.37a19.74,19.74,0,0,0-4.93,7.18,16.58,16.58,0,0,0-.81,7.75,16.47,16.47,0,0,0,28,9.46l14.22-14.22a6.34,6.34,0,0,1,3.11-1.73,5.56,5.56,0,0,1,3.36.2,8,8,0,0,1,3,1.89l57.58,57.58a6.35,6.35,0,0,1,1,7.78l-.3.35c-.67.68-58.11,58-58.63,58.54a6.25,6.25,0,0,1-3.34,1.76,6.74,6.74,0,0,1-1.16.1,6.31,6.31,0,0,1-4.5-1.87l-40.57-40.28,2-2,4-4a2.54,2.54,0,0,0-.85-4.14l-36.6-4.49a5.79,5.79,0,0,0-5.73,5.76Z",
    transform: "translate(-638.8 -419.68)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M926.83,513a6.3,6.3,0,0,1,.5,7.28s19.06-20.78,9.9-43.81l-12.06-12-17.58,29.2Z",
    transform: "translate(-638.8 -419.68)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M867.48,453.69c-21.47-19.77-45.14-8.78-45.14-8.78a18,18,0,0,0-4.37,6.64c3.18,1.56,26.27,18.09,26.27,18.09L857.9,456C862.79,450.12,867.48,453.69,867.48,453.69Z",
    transform: "translate(-638.8 -419.68)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M881.63,565.85s-13.77,13.86-13.8,13.8-3.67,2.94-7.53.23c0,0,22.87,18.82,47.33,7l7.15-7.16Z",
    transform: "translate(-638.8 -419.68)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfinityWalletLogo);
export default __webpack_public_path__ + "static/media/infinityWalletLogo.dbd83a4fe4d9130a6dc91755ed23a84e.svg";
export { ForwardRef as ReactComponent };